import request from '@/utils/request'


export function selectall(params) {
  return request({
    url: '/admin/store/cancelbook/selectall',
    method: 'get',
    params: params
  })
}

export function addReason(data) {
  return request({
    url: '/admin/store/cancelbook/addReason',
    method: 'post',
    data: data
  })
}

export function delReason(params) {
  return request({
    url: '/admin/store/cancelbook/delReason',
    method: 'get',
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/api/cancelBookReason.js